<template>
  <v-container>
    <v-row align="start" justify="center" class="mt-6 pa-2">
      <v-col cols="12" sm="8" md="6" class="elevation-4 pa-0" style="max-width:540px">
        <v-tabs v-model="category" fixed-tabs>
          <v-tab>Sign In</v-tab>
          <v-tab>Sign Up</v-tab>
        </v-tabs>
        <v-tabs-items v-model="category">
          <v-tab-item>
            <signin />
          </v-tab-item>
          <v-tab-item>
            <signup @success="category = 0" />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {
    Signin: () => import(/* webpackChunkName: "startup" */ "../cards/Signin"),
    Signup: () => import(/* webpackChunkName: "startup" */ "../cards/Signup")
  },

  data() {
    return {
      category: 0
    };
  },
};
</script>